export default {
  fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 600,
    fontSize: '2.5rem', // 40px -> 2.5rem
    lineHeight: 1.3 // 52px / 40px = 1.3 (建議用無單位倍數)
  },
  h2: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 600,
    fontSize: '2rem', // 32px -> 2rem
    lineHeight: 1.25 // 40px / 32px = 1.25
  },
  h3: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 600,
    fontSize: '1.5rem', // 24px -> 1.5rem
    lineHeight: 1.33 // 32px / 24px = 1.33...
  },
  h4: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 600,
    fontSize: '1.25rem', // 20px -> 1.25rem
    lineHeight: 1.2 // 24px / 20px = 1.2
  },
  h5: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 600,
    fontSize: '1rem', // 16px -> 1rem
    lineHeight: 1.5 // 24px / 16px = 1.5
  },
  h6: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 600,
    fontSize: '0.875rem', // 14px -> 0.875rem
    lineHeight: 1.43 // 20px / 14px = 1.43
  },
  subtitle1: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 400,
    fontSize: '1.25rem', // 20px -> 1.25rem
    lineHeight: 1.2 // 24px
  },
  subtitle2: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 500,
    fontSize: '0.75rem', // 12px -> 0.75rem
    lineHeight: 2 // 24px (這裡原本是 24px，對於 12px 字體來說是 2倍行高)
  },
  body1: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 400,
    fontSize: '1rem', // 16px -> 1rem
    lineHeight: 1.5 // 24px
  },
  body2: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 400,
    fontSize: '0.875rem', // 14px -> 0.875rem
    lineHeight: 1.43 // 20px
  },
  caption: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 400,
    fontSize: '0.75rem', // 12px -> 0.75rem
    lineHeight: 1.5 // 18px
  },
  button: {
    fontFamily: ['Noto Sans TC', 'sans-serif'].join(','),
    fontWeight: 400,
    fontSize: '1rem', // 16px -> 1rem
    lineHeight: 1.5 // 24px
  }
};
